import React, { FC } from 'react'
import { Formik, FormikProps } from 'formik'
import { t } from '@lingui/macro'
import { SignupSecondStepValues } from 'pages/native/onBoarding/types/types'
import { useUserData } from 'pages/native/onBoarding/context/OnBoardingContext'

import { SectionHeader } from 'pages/native/onBoarding/components'
import { SignupSecondStepForm } from '../Forms/SignupSecondStepForm/SignupSecondStepForm'
import { signupSecondStepValidation } from '../../schemas/signup.schema'
import useAuthentication from 'hooks/Authentication'
import { FormValidationError } from 'components/Forms/FormValidationError/FormValidationError'
import { useAnalytics } from 'utils/analytics/useAnalytics'

import styles from './SignupSecondStep.module.scss'
const initialFormValues: SignupSecondStepValues = {
  email: '',
  confirmEmail: '',
  password: '',
  confirmPassword: '',
  privacyPolicyChecked: false,
  emailConsent: false
}

interface Props {
  onSubmitForm: (values: SignupSecondStepValues) => void
  initialValues: SignupSecondStepValues
}

export const SignupSecondStep: FC<Props> = ({ onSubmitForm }) => {
  const { value: savedUserData } = useUserData()
  const { error } = useAuthentication()
  const { trackGtm, trackClarity } = useAnalytics()

  return (
    <div className={styles.ContentContainer}>
      <SectionHeader
        title={t`Almost there!`}
        body={t`Enter your details to unlock all the latest highlights from your followed teams.`}
      />
      <Formik
        initialValues={{ ...initialFormValues, ...savedUserData }}
        onSubmit={(values, actions) => {
          trackGtm('step2_user_details_completed_app', {
            emailEntered: !!values.email,
            emailConsent: values.emailConsent,
            privacyPolicyChecked: values.privacyPolicyChecked
          })
          trackClarity('step2_user_details_completed_app', {
            emailEntered: !!values.email,
            emailConsent: values.emailConsent,
            privacyPolicyChecked: values.privacyPolicyChecked
          })
          onSubmitForm(values)
          actions.setSubmitting(false)
        }}
        enableReinitialize
        validationSchema={signupSecondStepValidation}
        validateOnChange
        validateOnBlur
      >
        {(formik: FormikProps<SignupSecondStepValues>) => (
          <>
            {error?.message && (
              <FormValidationError errorMessage={error.message} />
            )}
            <SignupSecondStepForm formik={formik} />
          </>
        )}
      </Formik>
    </div>
  )
}
